import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { RouterModule, Routes } from '@angular/router';
import { UserPortalRoutingModule } from './user-portal-routing.module';
import { MyAssaysComponent } from './my-assays/my-assays.component';
import { MyAccountComponent } from './my-account/my-account.component';
import { MyFavoritesComponent } from './my-favorites/my-favorites.component';
import { MyListsComponent } from './my-lists/my-lists.component';
import { UserPortalLayoutComponent } from './user-portal-layout/user-portal-layout.component';

const routes: Routes = [
  { path: '', component: UserPortalLayoutComponent }
];

@NgModule({
  declarations: [MyAssaysComponent, MyAccountComponent, MyFavoritesComponent, MyListsComponent, UserPortalLayoutComponent],
  imports: [
    CommonModule,
    FormsModule,
    UserPortalRoutingModule,
    RouterModule.forChild(routes)
  ]
})
export class UserPortalModule { }
